/*
 * @Descripttion: 资讯表单管理
 * @Date: 2024-12-02 17:12:49
 */
import { route } from './src/router';

const name = 'information-form-mgmt';

export { name, route };
